import { useQuery } from '@tanstack/react-query';

import { me } from '../../lib/api/endpoints';

export const authKeys = {
  me: ['auth', 'me'] as const,
};

export function useMe() {
  return useQuery({
    queryKey: authKeys.me,
    queryFn: me,
    retry: false,
    staleTime: 30_000,
  });
}
